import { AnimatePresence, motion } from 'motion/react';

type AnimateHeightProps = {
  isTriggered: boolean;
  transitionTime?: number;
  delayTime?: number;
  children: React.ReactNode;
};

// Suitable for Accordions, FAQ, Wizard Panels,...
export const AnimateHeight = ({ children, isTriggered, transitionTime = 0.3, delayTime = 0 }: AnimateHeightProps) => {
  const animationProps = {
    closed: { height: 0, opacity: 0, overflow: 'hidden', transition: { delay: delayTime, duration: transitionTime } },
    open: {
      height: 'auto',
      opacity: 1,
      overflow: 'visible',
      transition: { delay: delayTime, duration: transitionTime },
    },
  };

  return (
    <AnimatePresence>
      {isTriggered && (
        <motion.div variants={animationProps} initial="closed" animate="open" exit="closed">
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
